import validateRequiredProps from 'utils/validateRequiredProps';
import {Record} from 'immutable';

export function validate(account) {
  return validateRequiredProps(account, ['name']);
}

export default class CrmAccount extends Record({
  id: null,
  name: null,
  avatar: null,
}) {
  constructor(object = {}) {
    super({
      ...object,
      id: object.id || object.crmId,
    });
  }
}
